<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useAuthenticationStore } from "@/stores/authentication.js";

export default {
  setup() {
    // Stores
    const modalStore = useModalStore();
    const authenticationStore = useAuthenticationStore();

    // I18n
    const { t } = useI18n();

    return {
      t,
      modalStore
    }
  },
};
</script>

<template>
</template>

<style lang="scss" scoped>
</style>